export default __webpack_public_path__ + "static/media/pool-temp-light.cda93bc8.svg";